import { z } from "zod/v4";

/**
 * A user sent a trigger command to the sirens and/or strobes on an asset.
 *
 * Deterrence hardware is asset-level, so the entry's camera is the one the
 * command was sent through, not the only one affected. `topic` and
 * `publishedAt` are the publish receipt, so an entry can be tied to the edge
 * log line it caused.
 *
 * Note what this does **not** claim: the entry records that a command was
 * accepted for delivery, not that the hardware sounded. The edge reports no
 * acknowledgement.
 */
export const DeterrenceTriggeredActivityMetadata = z.object({
  // Mirrors `DeterrenceDevice` in `@visioni/a3s-deterrence`; a package cannot
  // depend on a feature.
  devices: z.array(z.enum(["siren", "strobe"])).min(1),
  topic: z.string(),
  publishedAt: z.iso.datetime(),
});
export type DeterrenceTriggeredActivityMetadata = z.infer<typeof DeterrenceTriggeredActivityMetadata>;

/**
 * A user sent a stop command to every siren and strobe on an asset. Same receipt, and
 * the same caveat, as {@link DeterrenceTriggeredActivityMetadata}.
 */
export const DeterrenceStoppedActivityMetadata = z.object({
  topic: z.string(),
  publishedAt: z.iso.datetime(),
});
export type DeterrenceStoppedActivityMetadata = z.infer<typeof DeterrenceStoppedActivityMetadata>;
